import React from "react";
import { Box, Label } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";

interface BadgesContainerProps {
  badgeList: {
    label: string;
    variant: "Default" | "Update" | "Negative" | "Alert";
  }[];
}

const colorVariant = {
  Default: "#374d62",
  Update: "secondary-green",
  Negative: "primary-red",
  Alert: "secondary-orange",
};

const StyledBox = styled(Box)`
  list-style-type: none;
`;

const StyledLi = styled.li<{ children: React.ReactNode }>`
  ${css({
    mb: 2,
    mr: 2,
  })};
`;

const BadgesContainer: React.FunctionComponent<BadgesContainerProps> = ({
  badgeList,
}) => {
  return (
    <StyledBox as="ul" mb={1} mt={0} display="flex" flexWrap="wrap" px={0}>
      {badgeList.map(
        (badge) =>
          Boolean(badge.label) && (
            <StyledLi key={badge.label}>
              <Label
                backgroundColor={colorVariant[badge.variant]}
                label={badge.label}
                height="24px"
              ></Label>
            </StyledLi>
          )
      )}
    </StyledBox>
  );
};

export default BadgesContainer;
